import { ReminderCancellationPlan } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/ReminderSubscriptionEndBanner/ReminderCancellationPlan';
import { ReminderTrialEnd } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/ReminderSubscriptionEndBanner/ReminderTrialEnd';

export function ReminderSubscriptionEndBanner() {
    return (
        <>
            <ReminderTrialEnd />
            <ReminderCancellationPlan />
        </>
    );
}
